import styled, { keyframes } from "styled-components";
import { colors } from "../../../styles/colors";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(18, 34, 67, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  direction: rtl;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const Content = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 40px rgba(18, 34, 67, 0.3);
  animation: ${slideUp} 0.3s ease-out;
  text-align: center;

  @media (max-width: 768px) {
    padding: 24px;
    max-width: 90%;
  }
`;

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, ${colors.gradientTeal}, ${colors.gradientBlue});
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

export const Title = styled.h2`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin: 0 0 8px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.blueGray};
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const AccountList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
`;

export const AccountCard = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid ${colors.lightGrayBlue};
  background: ${colors.white};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: right;
  direction: rtl;

  &:hover {
    background: ${colors.lightGray};
    border-color: ${colors.blueGray};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(18, 34, 67, 0.08);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const AccountAvatar = styled.div<{ $src?: string }>`
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: 50%;
  background: ${({ $src }) =>
    $src
      ? `url(${$src}) center/cover no-repeat`
      : `linear-gradient(135deg, ${colors.gradientTeal}, ${colors.gradientBlue})`};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 18px;
  font-weight: 600;
`;

export const AccountInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const AccountName = styled.span`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${colors.darkBlue};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AccountPhone = styled.span`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: ${colors.blueGray};
  direction: ltr;
  text-align: right;
`;

export const ErrorMessage = styled.div`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 14px;
  margin-top: 16px;
  text-align: center;
  color: ${colors.red};
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid ${colors.lightGrayBlue};
  border-top-color: ${colors.blue};
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
  margin: 20px auto;
`;
